<template>
  <div>
    <div v-if="isBPattern" class="topPageHeader">
      <top-header :banners="props.banners" />
      <week-day-event />
      <date-search-button class="topPageHeader-dateButton" />
    </div>
    <top-simple-search v-else class="opixTopSimpleSearch" />
  </div>
</template>

<script setup lang="ts">
import type { TopBanner } from '@/types/TopBanner'
import { useABTest } from '@/composables/abtest/useABTest'
import { TOP_FV_AB_TEST_CONFIG } from '@/composables/abtest/abTestConfig'
import { sendABTestGAEvent } from '@/composables/abtest/gaEvent'
import { AB_TEST_GA_EVENT_TARGETS } from '@/composables/abtest/gaEventConfig'

const props = defineProps<{
  banners: TopBanner[]
}>()

const { isBPattern } = useABTest(TOP_FV_AB_TEST_CONFIG)

onMounted(() => {
  sendABTestGAEvent(AB_TEST_GA_EVENT_TARGETS.VIEW_TOP)
})

const TopHeader = defineAsyncComponent(() => import('@/components/top/TopHeader.vue'))
const TopSimpleSearch = defineAsyncComponent(() => import('@/components/search/TopSimpleSearch.vue'))
const DateSearchButton = defineAsyncComponent(() => import('@/components/top/DateSearchButton.vue'))
const WeekDayEvent = defineAsyncComponent(() => import('@/components/top/WeekDayEvent.vue'))
</script>

<style lang="scss" scoped>
.topPageHeader {
  margin: 0 auto;
}
</style>
